import * as React from 'react';
import { lazyInject } from '../../services/inversify';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { WFormsTableWrapper } from '../table/WFormsTableWrapper';
import { IDs } from '../IDs';
import { RechteService } from '../../services/rechte_service';
import style from './WRechte.less';
import { WDnd } from '../forms/WDnd';

interface WRechteUserProps extends React.ClassAttributes<any> {
    modul: string;
    stamp: number;
    rechteBasis: any;
    costumClass?: string;
    formLayout?: string;
    onDataChange?: () => void;
}

interface WRechteUserState {
    user: Array<any>;
    showZuordnenDialog: boolean;
    showEffctivRechteDialog: boolean;
    showItem: any;
    userRechteLists: any;
    userGroupsLists: any;
}

export class WRechteUser extends React.Component<WRechteUserProps, WRechteUserState> {

    constructor(props: any) {
        super(props);

        this.state = {
            user: [],
            showZuordnenDialog: false,
            showEffctivRechteDialog: false,
            showItem: {},
            userRechteLists: {},
            userGroupsLists: {}
        };

        this.updateUser = this.updateUser.bind(this);
        this.prepareUserRechteLists = this.prepareUserRechteLists.bind(this);
        this.prepareUserGroupsLists = this.prepareUserGroupsLists.bind(this);
        this.saveUserRechteLists = this.saveUserRechteLists.bind(this);
        this.saveUserGroupsLists = this.saveUserGroupsLists.bind(this);
    }

    @lazyInject(RechteService) private rechteService: RechteService;

    private title = {
        SELECTED: 'zugeordnet',
        OPTIONS: 'nicht zugeordnet'
    };

    componentDidMount() {
        if (this.state.user.length === 0) {
            this.updateUser();
        }
    }

    componentDidUpdate(preProps: any, preState: any) {
        if (preProps.stamp !== this.props.stamp) {
            this.updateUser();
        }

        if (preState.showItem.tid !== this.state.showItem.tid) {
            this.prepareUserRechteLists();
            this.prepareUserGroupsLists();
        }
    }

    updateUser() {
        const rechteBasis = this.props.rechteBasis;
        if (Array.isArray(rechteBasis.entity_user) &&
            Array.isArray(rechteBasis.group_items) &&
            Array.isArray(rechteBasis.access_user)) {

            const user: Array<any> = [];
            rechteBasis.entity_user.map((iu: any) => {
                const login = iu.login ? iu.login : iu.Login ? iu.Login : iu.name;
                const groups: Array<string> = [];
                rechteBasis.group_items.map((igi: any) => {
                    if (igi.name === login) {
                        // console.log('Igi', login, igi);
                        groups.push(igi.group_tid);
                    }
                });
                iu.cntGroup = groups.length;
                iu.groups = groups.sort().join(', ');

                let cntRecht = 0;
                rechteBasis.access_user.map((iau: any) => {
                    if (iau.name === login) {
                        cntRecht++;
                    }
                });
                iu.cntRecht = cntRecht;
                user.push(iu);
            });
            // console.log('User', user);
            // console.log(access);
            this.setState({ user });
        }
    }

    render() {
        const customActions = [
            {
                label: 'Rechte und Gruppen zuordnen',
                key: 'REFERENCE',
                func: ((row: any) => {
                    this.setState({ showZuordnenDialog: true, showItem: row });
                    return;
                }),
                info: 'Rechte und Gruppen zuordnen'
            },
            {
                label: 'Effektive Rechte anzeigen',
                key: 'info',
                func: ((row: any) => {
                    this.setState({ showEffctivRechteDialog: true, showItem: row });
                    return;
                }),
                info: 'Effektive Rechte anzeigen'
            }
        ];

        return (
            <div>
                <WFormsTableWrapper
                    module={this.props.modul}
                    entity={IDs.ENT_LEGACY_USER}
                    data={this.state.user}
                    hiddenColumns={['pass']}
                    actions={['add', 'edit', 'delete']}
                    customActions={customActions}
                    customClass={this.props.costumClass ? this.props.costumClass : null}
                    formLayout={this.props.formLayout ? this.props.formLayout : null}
                    customColumns={[
                        { accessor: 'groups', Header: 'Gruppen', id: 'groups' },
                        { accessor: 'cntGroup', Header: 'Anzahl Gruppen', id: 'cntGroup' },
                        { accessor: 'cntRecht', Header: 'Anzahl Rechte', id: 'cntRecht' }
                    ]}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' && typeof this.props.onDataChange === 'function') {
                            this.props.onDataChange();
                        }
                    }}
                />
                {this.state.showZuordnenDialog && this.showZuordnenDialog()}
                {this.state.showEffctivRechteDialog && this.showEffctivRechteDialog()}
            </div>
        );
    }

    showZuordnenDialog() {
        return (
            <div>
                <DialogWrapper2
                    title='Rechte und Gruppen zuordnen'
                    onAfterClose={() => this.setState({ showZuordnenDialog: false, showItem: {} })}
                >
                    <div>
                        <div>
                            <div className={style.dnd_box}>
                                <div>Gruppen dieses Benutzers</div>
                                <div>
                                    <WDnd
                                        title={this.title}
                                        lists={this.state.userGroupsLists}
                                        onChange={(list: any) => this.setState({ userGroupsLists: list })}
                                    />
                                </div>
                            </div>
                            <div className={style.dnd_box}>
                                <div>Rechte dieses Benutzers</div>
                                <div>
                                    <WDnd
                                        title={this.title}
                                        lists={this.state.userRechteLists}
                                        onChange={(list: any) => this.setState({ userRechteLists: list })}
                                    />
                                </div>
                            </div>
                        </div>
                        <button
                            style={{ padding: '5px 10px', margin: 5, float: 'right' }}
                            onClick={() => {
                                this.setState({ showZuordnenDialog: false, showItem: {} });
                                // console.log(this.state);
                                // console.log(this.props.rechteBasis);
                                this.saveUserRechteLists();
                                this.saveUserGroupsLists();
                            }}>Speichern</button>
                    </div>
                </DialogWrapper2>
            </div>
        );
    }

    showEffctivRechteDialog() {
        const iu = this.state.showItem;
        const login = iu.login ? iu.login : iu.Login ? iu.Login : iu.name;
        const userRechte = this.rechteService.getUserEffctivRechte(login);
        return (
            <div>
                <DialogWrapper2
                    title='Effektive Rechte anzeigen'
                    onAfterClose={() => this.setState({ showEffctivRechteDialog: false, showItem: {} })}
                >
                    <textarea
                        style={{ minWidth: '400px', width: '95%', resize: 'none', padding: '5px' }}
                        rows={20}
                        readOnly={true}
                        value={userRechte.join('\n')}
                    />
                </DialogWrapper2>
            </div>
        );
    }

    prepareUserRechteLists() {
        const userRechteLists: any = {
            SELECTED: [],
            OPTIONS: []
        };
        if (Array.isArray(this.props.rechteBasis.access)) {
            this.props.rechteBasis.access.map((it: any) => {
                userRechteLists.OPTIONS.push({
                    id: it.tid,
                    content: it.info
                });
            });
        }
        const iu = this.state.showItem;
        const login = iu.login ? iu.login : iu.Login ? iu.Login : iu.name;
        if (login && Array.isArray(this.props.rechteBasis.access_user)) {
            this.props.rechteBasis.access_user.map((it: any) => {
                if (it.name === login) {
                    const opIdx = userRechteLists.OPTIONS.findIndex((it2: any) => { return it2.id === it.access_id_orig; });
                    if (opIdx >= 0) {
                        const opItemArray = userRechteLists.OPTIONS.splice(opIdx, 1);
                        userRechteLists.SELECTED.push(opItemArray[0]);
                    }
                }
            });
        }
        console.log('UserRechteLists: ', userRechteLists);
        this.setState({ userRechteLists });
    }

    prepareUserGroupsLists() {
        const userGroupsLists: any = {
            SELECTED: [],
            OPTIONS: []
        };
        if (Array.isArray(this.props.rechteBasis.group_index)) {
            this.props.rechteBasis.group_index.map((it: any) => {
                userGroupsLists.OPTIONS.push({
                    id: it.tid,
                    content: it.name
                });
            });
        }
        const iu = this.state.showItem;
        const login = iu.login ? iu.login : iu.Login ? iu.Login : iu.name;
        console.log('GroupItems', this.props.rechteBasis.group_items, login);
        if (login && Array.isArray(this.props.rechteBasis.group_items)) {
            this.props.rechteBasis.group_items.map((it: any) => {
                if (it.name === login) {
                    const group_id = it.group_id_orig || it.group_tid_orig;
                    const opIdx = userGroupsLists.OPTIONS.findIndex((it2: any) => { return it2.id === group_id; });
                    if (opIdx >= 0) {
                        const opItemArray = userGroupsLists.OPTIONS.splice(opIdx, 1);
                        userGroupsLists.SELECTED.push(opItemArray[0]);
                    }
                }
            });
        }
        this.setState({ userGroupsLists });
    }

    saveUserRechteLists() {
        const { userRechteLists } = this.state;
        const { SELECTED, OPTIONS } = userRechteLists;
        const access_user = this.props.rechteBasis.access_user;
        const user = this.state.showItem.login;
        let callCnt = 0;

        const callback = () => {
            callCnt--;
            if (callCnt === 0) {
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            }
        };

        // selected but not exisits -> add
        SELECTED.forEach((s: any) => {
            const accessId = parseInt(s.id, 10);
            const fnd = access_user.find((au: any) => au.access_id_orig === accessId && au.name === user);
            if (!fnd) {
                console.log('addAccessUser', user, accessId);
                callCnt++;
                this.rechteService.addAccessUser(accessId, user, callback);
            }
        });
        // not selected but exists -> delete
        OPTIONS.forEach((o: any) => {
            const accessId = parseInt(o.id, 10);
            access_user.filter((au: any) => au.access_id_orig === accessId && au.name === user)
                .forEach((au: any) => {
                    console.log('delAccessUser', au.tid, au.access_id);
                    callCnt++;
                    this.rechteService.delAccessUser(au.tid, callback);
                });
        });
    }

    saveUserGroupsLists() {
        const { userGroupsLists } = this.state;
        const { SELECTED, OPTIONS } = userGroupsLists;
        const group_items = this.props.rechteBasis.group_items;
        const user = this.state.showItem.login;
        let callCnt = 0;

        const callback = () => {
            callCnt--;
            if (callCnt === 0) {
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            }
        };

        // selected but not exisits -> add
        SELECTED.forEach((s: any) => {
            const groupTid = parseInt(s.id, 10);
            const fnd = group_items.find((gi: any) => gi.group_tid_orig === groupTid && gi.name === user);
            if (!fnd) {
                console.log('addGroupUser', user, groupTid);
                callCnt++;
                this.rechteService.addGroupUser(groupTid, user, callback);
            }
        });
        // not selected but exists -> delete
        OPTIONS.forEach((o: any) => {
            const groupTid = parseInt(o.id, 10);
            group_items.filter((gi: any) => gi.group_tid_orig === groupTid && gi.name === user)
                .forEach((gi: any) => {
                    console.log('delGroupUser', gi.tid, gi.group_tid);
                    callCnt++;
                    this.rechteService.delGroupUser(gi.tid, groupTid, callback);
                });
        });
    }
}
